import { TimeIcon } from "../icons/TimeIcon";
import { StopWatch } from "../StopWatch";

function CardTimerStats({ 
    initialTime = 0, 
    initialStartDate = null, 
    withIcon = false 
}) {
    if (initialTime <= 0) {
        return null;
    }

    if (withIcon) {
        return (
            <div className='d-flex align-items-center'>
                <TimeIcon color="#727580" height={16} width={16} className={'me-1'}/>
                <span>
                    <StopWatch
                        initialTime={initialTime}
                        initialStartDate={initialStartDate}
                        isActive={false}
                    />
                </span>
            </div>
        )
    }

    return (
        <StopWatch
            initialTime={initialTime}
            initialStartDate={initialStartDate}
            isActive={false}
        />
    )
}

export { CardTimerStats };